import React, { useEffect, useState } from 'react';
import Layout from '../../Components/Layout';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { ToWords } from 'to-words';


const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
        currency: false,
        ignoreDecimal: true,
    },
});

const InvoiceCreate = () => {
    const [orderList, setOrderList] = useState([]);
    const location = useLocation();

    const isEdit = location.state?.isEdit || false;

    const invoiceId = location.state?.invoiceId || null;

    const [invoiceData, setInvoiceData] = useState({
        // invoiceNo: '',
        po: '',
        date: '',
        companyFor: '',
        billTo: '',
        shipTo: '',
        contactPerson: '',
        orderId: '',
        organizationName: '',
        gstNumber: '',
        gstType: '',
        cgst: 0,
        sgst: 0,
        igst: 0,
        paymentStatus: '',
        amountInWords: '',

        items: [
            {
                description: '',
                sac: '',
                price: '',
            },
        ],
    });

    const fetchInvoiceById = async () => {

        try {

            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/invoices/${invoiceId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const invoice = response.data;
            const orderResponse = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/orders/${invoice.orderId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const order = orderResponse.data;

            setInvoiceData({
                orderId: invoice.orderId || '',
                date: invoice.date || '',
                companyFor: invoice.companyFor || '',
                billTo: invoice.billTo || '',
                shipTo: invoice.shipTo || '',
                contactPerson: invoice.contactPerson || '',
                paymentStatus: invoice.paymentStatus || '',
                amountInWords: invoice.amountInWords || '',
                organizationName: order.organizationName || '',

                gstType: order.gstType || '',

                items: invoice.items || [],

                cgst: invoice.cgst || 0,
                sgst: invoice.sgst || 0,
                igst: invoice.igst || 0,
            });

        } catch (error) {

            console.log(error);

            toast.error("Failed To Fetch Invoice");
        }
    };
    const fetchOrders = async () => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/orders?page=0&size=100`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setOrderList(response.data.content);

        } catch (error) {
            console.error(error);
            toast.error("Failed To Fetch Orders");
        }
    };

    useEffect(() => {

        fetchOrders();

        if (isEdit && invoiceId) {
            fetchInvoiceById();
        }

    }, []);


    // Main Input Change
    const handleChange = (e) => {
        const { name, value } = e.target;

        setInvoiceData({
            ...invoiceData,
            [name]: value,
        });
    };



    const handleItemChange = (index, field, value) => {

        const updatedItems = [...invoiceData.items];

        updatedItems[index][field] = value;

        const subtotal = updatedItems.reduce(
            (acc, item) => acc + Number(item.price || 0),
            0
        );

        let cgst = 0;
        let sgst = 0;
        let igst = 0;

        if (invoiceData.gstType === "INTER_STATE") {
            igst = subtotal * 0.18;
        } else if (invoiceData.gstType) {
            cgst = subtotal * 0.09;
            sgst = subtotal * 0.09;
        }

        const total = subtotal + cgst + sgst + igst;

        setInvoiceData({
            ...invoiceData,
            items: updatedItems,
            amountInWords:
                total > 0
                    ? `${toWords.convert(Math.round(total))} Rupees Only`
                    : '',
        });
    };
    // Add Row
    const addMoreRow = () => {

        setInvoiceData({
            ...invoiceData,
            items: [
                ...invoiceData.items,
                {
                    description: '',
                    sac: '',
                    price: '',
                },
            ],
        });
    };

    // Remove Row
    const removeRow = (index) => {

        if (invoiceData.items.length === 1) return;

        const updatedItems = invoiceData.items.filter(
            (_, i) => i !== index
        );

        setInvoiceData({
            ...invoiceData,
            items: updatedItems,
        });
    };


    const subtotal = invoiceData.items.reduce(
        (acc, item) => acc + Number(item.price || 0),
        0
    );

    let cgst = 0;
    let sgst = 0;
    let igst = 0;

    if (invoiceData.gstType === "INTER_STATE") {
        igst = subtotal * 0.18;
    } else if (invoiceData.gstType) {
        cgst = subtotal * 0.09;
        sgst = subtotal * 0.09;
    }

    const total = subtotal + cgst + sgst + igst;


    const navigate = useNavigate();

    const handleCreateInvoice = async () => {

        try {

            const token = localStorage.getItem("token");

            const finalInvoiceData = {
                orderId: Number(invoiceData.orderId),

                date: invoiceData.date,
                companyFor: invoiceData.companyFor,
                billTo: invoiceData.billTo,
                shipTo: invoiceData.shipTo,

                paymentStatus: invoiceData.paymentStatus,

                contactPerson: invoiceData.contactPerson,

                amountInWords: invoiceData.amountInWords,

                subtotal: Number(subtotal.toFixed(2)),

                total: Number(total.toFixed(2)),

                cgst: Number(cgst.toFixed(2)),
                sgst: Number(sgst.toFixed(2)),
                igst: Number(igst.toFixed(2)),

                items: invoiceData.items,
            };
            console.log("Invoice Payload => ", finalInvoiceData);

            if (isEdit) {

                await axios.patch(
                    `${process.env.REACT_APP_BACKEND_URL}/invoices/${invoiceId}`,
                    finalInvoiceData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                toast.success("Invoice Updated Successfully");

            } else {

                await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}/invoices`,
                    finalInvoiceData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                toast.success("Invoice Created Successfully");
            }





            navigate("/list-invoice");

        } catch (error) {

            console.error("Create Invoice Error => ", error);

            console.log(error.response);
            toast.error("Failed To Create Invoice")


        }
    };

    const handleOrderSelect = async (e) => {

        const orderId = e.target.value;

        try {

            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/orders/${orderId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const order = response.data;

            const address =
                `${order.address?.streetLine1 || ''},
            ${order.address?.streetLine2 || ''},
            ${order.address?.city || ''},
            ${order.address?.state || ''},
            ${order.address?.country || ''},
            ${order.address?.postalCode || ''}`;

            setInvoiceData((prev) => ({
                ...prev,

                orderId: order.orderId,
                billTo: address,
                contactPerson: order.mobileNumber,
                organizationName: order.organizationName,
                gstNumber: order.gstNumber,

                gstType: order.gstType,
            }));

        } catch (error) {

            console.log(error);

            toast.error("Failed To Fetch Order");
        }
    };

    return (
        <Layout>

            <div className="backgound-main-content py-4">

                <div className="container-fluid">
                    <button
                        className="btn btn-primary"
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </button>

                    <div
                        className="bg-white border p-3 mt-2"
                        style={{
                            maxWidth: '1100px',
                            margin: '0 auto',
                        }}
                    >

                        {/* Header */}
                        <div className="text-center border-bottom pb-2">

                            <h2 className="fw-bold mb-1">
                                RAK SOFTECH PRIVATE LTD
                            </h2>

                            <p className="mb-0">
                                Office no 3, 3rd floor, Mayuri plaza,
                                above SBI, Near Bhoir Hospital,
                                Dange Chowk, Chinchwad Pune 411033
                            </p>

                            <p className="mb-0">
                                email: kavitay@raksoftech.com
                                | Ph: 91-9588614798
                            </p>

                        </div>

                        {/* GST */}
                        <div className="row border border-top-0 m-0">

                            <div className="col-md-6 border-end py-2 fw-bold">
                                GSTIN - 27AAHCR9750J1ZS
                            </div>

                            <div className="col-md-6 py-2 text-center fw-bold">
                                GST INVOICE
                            </div>

                        </div>

                        {/* Invoice Details */}
                        <div className="row border border-top-0 m-0">

                            <div className="col-md-6 py-2">
                                {/*
                                <div className="mb-2">
                                    <label className="fw-bold">
                                        Invoice No
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        name="invoiceNo"
                                        value={invoiceData.invoiceNo}
                                        onChange={handleChange}
                                    />
                                </div>
                                */}

                                <div className="col-md-6">

                                    <label className="fw-bold">
                                        Order Id
                                    </label>

                                    <select
                                        className="form-select"
                                        name="orderId"
                                        value={invoiceData.orderId}
                                        onChange={handleOrderSelect}
                                    >
                                        <option value="">
                                            Select Order
                                        </option>

                                        {orderList.map((order) => (
                                            <option
                                                key={order.orderId}
                                                value={order.orderId}
                                            >
                                                {order.orderId}
                                            </option>
                                        ))}
                                    </select>

                                </div>


                                <div className="row mt-2">

                                    <div className="mt-2">

                                        <label className="fw-bold">
                                            Organization Name
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="organizationName"
                                            value={invoiceData.organizationName}

                                        />

                                    </div>

                                    {/* Payment Status */}
                                    {isEdit && (
                                        <div className="col-md-6">
                                            <label className="fw-bold">
                                                Payment Status
                                            </label>

                                            <select
                                                className="form-select"
                                                name="paymentStatus"
                                                value={invoiceData.paymentStatus}
                                                onChange={handleChange}
                                            >
                                                <option value="">
                                                    Select Payment Status
                                                </option>

                                                <option value="PAID">
                                                    Paid
                                                </option>

                                                <option value="PENDING">
                                                    Pending
                                                </option>
                                            </select>
                                        </div>
                                    )}

                                </div>

                            </div>

                            <div className="col-md-6 py-2">

                                <div className="mb-2">

                                    <label className="fw-bold">
                                        Date
                                    </label>

                                    <input
                                        type="date"
                                        className="form-control"
                                        name="date"
                                        value={invoiceData.date}
                                        onChange={handleChange}
                                    />

                                </div>

                                <div>

                                    <label className="fw-bold">
                                        FOR
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        name="companyFor"
                                        value={invoiceData.companyFor}
                                        onChange={handleChange}
                                    />

                                </div>

                            </div>

                        </div>

                        {/* Address */}
                        <div className="row border border-top-0 m-0">

                            <div className="col-md-6 border-end py-2">

                                <label className="fw-bold">
                                    Bill To
                                </label>

                                <textarea
                                    rows="4"
                                    className="form-control"
                                    name="billTo"
                                    value={invoiceData.billTo}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-6 py-2">

                                <label className="fw-bold">
                                    Ship To
                                </label>

                                <textarea
                                    rows="2"
                                    className="form-control mb-2"
                                    name="shipTo"
                                    value={invoiceData.shipTo}
                                    onChange={handleChange}
                                />

                                <label className="fw-bold">
                                    Contact Person
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="contactPerson"
                                    value={invoiceData.contactPerson}
                                    onChange={handleChange}
                                />

                            </div>

                        </div>

                        {/* Table */}
                        <div className="table-responsive">

                            <table
                                className="table table-bordered mb-0"
                                style={{
                                    tableLayout: 'fixed',
                                    width: '100%',
                                }}
                            >

                                <thead>

                                    <tr>
                                        <th style={{ width: '45%' }}>
                                            DESCRIPTION
                                        </th>

                                        <th style={{ width: '20%' }}>
                                            SAC
                                        </th>

                                        <th style={{ width: '20%' }}>
                                            AMOUNT
                                        </th>

                                        <th style={{ width: '15%' }}>
                                            ACTION
                                        </th>
                                    </tr>

                                </thead>

                                <tbody>

                                    {invoiceData.items.map((item, index) => (

                                        <tr key={index}>

                                            <td>
                                                <textarea
                                                    rows="2"
                                                    className="form-control"
                                                    value={item.description}
                                                    onChange={(e) =>
                                                        handleItemChange(
                                                            index,
                                                            'description',
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </td>

                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={item.sac}
                                                    onChange={(e) =>
                                                        handleItemChange(
                                                            index,
                                                            'sac',
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </td>

                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={item.price}
                                                    onChange={(e) =>
                                                        handleItemChange(
                                                            index,
                                                            'price',
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </td>

                                            <td className="text-center">

                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => removeRow(index)}
                                                >
                                                    Remove
                                                </button>

                                            </td>

                                        </tr>

                                    ))}

                                    {/* Totals */}
                                    {invoiceData.gstType === "INTER_STATE" ? (
                                        <tr>
                                            <td colSpan="2" className="text-end fw-bold">
                                                IGST
                                            </td>

                                            <td colSpan="2">
                                                ₹ {igst.toFixed(2)}
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            <tr>
                                                <td colSpan="2" className="text-end fw-bold">
                                                    CGST
                                                </td>

                                                <td colSpan="2">
                                                    ₹ {cgst.toFixed(2)}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td colSpan="2" className="text-end fw-bold">
                                                    SGST
                                                </td>

                                                <td colSpan="2">
                                                    ₹ {sgst.toFixed(2)}
                                                </td>
                                            </tr>
                                        </>
                                    )}

                                    <tr>
                                        <td colSpan="2" className="text-end fw-bold">
                                            TOTAL
                                        </td>

                                        <td colSpan="2" className="fw-bold">
                                            ₹ {total.toFixed(2)}
                                        </td>
                                    </tr>



                                </tbody>

                            </table>

                        </div>

                        {/* Add More */}
                        <div className="mt-3">

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={addMoreRow}
                            >
                                Add More
                            </button>

                        </div>

                        {/* Amount In Words */}
                        <div className="border p-3 mt-3">

                            <label className="fw-bold">
                                Amount In Words
                            </label>

                            <textarea
                                rows="3"
                                className="form-control"
                                name="amountInWords"
                                value={invoiceData.amountInWords}
                                readOnly
                            />

                        </div>


                        <div className="mt-3 mb-3">

                            {/* Create Invoice */}
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleCreateInvoice}
                            >
                                {isEdit ? "Update Invoice" : "Create Invoice"}
                            </button>

                        </div>

                        {/* Footer */}
                        <div className="text-center fw-bold border p-2">
                            THANK YOU FOR YOUR BUSINESS!
                        </div>

                    </div>

                </div>

            </div>

        </Layout>
    );
};

export default InvoiceCreate;